import { z } from "zod"
import { BankAccountOwnerType, BankAccountType } from "@/api/bank-accounts"

export const bankAccountFormSchema = z
  .object({
    type: z.nativeEnum(BankAccountType),
    firstName: z
      .string()
      .min(1, { message: "First name is required" })
      .optional(),
    lastName: z
      .string()
      .min(1, { message: "Last name is required" })
      .optional(),
    bankName: z.string().min(1, { message: "Bank name is required" }),
    businessName: z.string().optional(),
    accountOwnerType: z.nativeEnum(BankAccountOwnerType),
    userAddressId: z.string().min(1, { message: "Address is required" }),
    usDetails: z
      .object({
        accountNumber: z
          .string()
          .min(1, { message: "Account number is required" }),
        routingNumber: z
          .string()
          .length(9, { message: "Routing number must be 9 digits" }),
      })
      .optional(),
    euDetails: z
      .object({
        iban: z
          .string()
          .min(1, { message: "IBAN is required" })
          .regex(/^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/, { message: "Invalid IBAN" }),
        bic: z.string().min(1, { message: "BIC is required" }),
      })
      .optional(),
  })
  .refine(
    (data) => {
      if (data.accountOwnerType === BankAccountOwnerType.INDIVIDUAL) {
        return data.firstName && data.lastName
      } else {
        return true
      }
    },
    {
      message: "Required for individual account owners",
      path: ["firstName", "lastName"],
    },
  )
  .refine(
    (data) => {
      if (data.accountOwnerType === BankAccountOwnerType.BUSINESS) {
        return data.businessName
      } else {
        return true
      }
    },
    {
      message: "Required for business account owners",
      path: ["businessName"],
    },
  )
  .refine(
    (data) => {
      if (data.type === BankAccountType.US) {
        return data.usDetails !== undefined
      } else if (data.type === BankAccountType.EU) {
        return data.euDetails !== undefined
      } else {
        return true
      }
    },
    {
      message: "Required details for the selected account type",
      path: ["usDetails", "euDetails"],
    },
  )
